import { createSlice } from "@reduxjs/toolkit";

// Safe read from localStorage
const savedMenu =
  typeof window !== "undefined" ? localStorage.getItem("selectedMenu") : null;
  
// Load selected menu from localStorage or default to 'Dashboard'
const initialSelectedMenu =
  typeof window !== "undefined" && localStorage.getItem("selectedMenu")
    ? localStorage.getItem("selectedMenu")
    : "Dashboard";

const sidebarSlice = createSlice({
  name: "sidebar",
  initialState: {
    refreshSidebar: false,
    selectedMenu: initialSelectedMenu,
  },
  reducers: {
    setRefreshSidebar: (state, action) => {
      state.refreshSidebar = action.payload;
    },
    setSelectedMenu: (state, action) => {
      state.selectedMenu = action.payload;

      // Save to localStorage to persist across page refresh
      localStorage.setItem("selectedMenu", action.payload);
    },
    resetSidebarState: (state) => {
      // Clear both Redux and localStorage state
      state.selectedMenu = "Dashboard";
      localStorage.removeItem("selectedMenu");
    },
  },
});

export const {
  setRefreshSidebar,
  setSelectedMenu,
  resetSidebarState, // 👈 use this in logout
} = sidebarSlice.actions;

export default sidebarSlice.reducer;
